module.exports = __webpack_public_path__ + "static/img/dso_cokol.c2b5c52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia_KOPIA/dso_cokol.svg
// module id = Qa3f
// module chunks = 1